const nsvRoutes = {
	customerJourney: {
		path: '/nunca-sin-vino/customer-journey',
		name: 'CustomerJourneyNSV',
		component: () => import('@/views/CustomerJourneyNSV.vue'),
		meta: { title: 'Customer Journey' }
	}
}

export default nsvRoutes
